"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createCommand } from 'lexical';

const INSERT_EDITOR_TAG_COMMAND = createCommand();

export { INSERT_EDITOR_TAG_COMMAND };
